module.exports = __webpack_public_path__ + "static/media/main-weapon.63c90d0a.png";